import NewsItemModal from "./NewsItemModal";

export default NewsItemModal;
